/*	Dummy javascript file	*/

function hello () {
	return 'hello world' }